/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import React, {MouseEventHandler} from 'react';
import {useNavigate} from 'react-router';
import {HeaderItem} from "../../util/interfaces";
import DvrdHeader from "./dvrdHeader";

interface Props {
    onClickItem?: (item: HeaderItem) => MouseEventHandler;
    leftItems?: Array<HeaderItem>;
    rightItems?: Array<HeaderItem>;
    backgroundColor?: string;
    color?: string;
    className?: string;
    itemClassName?: string;
}

export default function DvrdHeaderController(props: Props) {
    const {leftItems, onClickItem, rightItems, itemClassName, className, backgroundColor, color} = props;
    const navigate = useNavigate();

    function _onClickItem(item: HeaderItem) {
        return function (evt: React.MouseEvent) {
            if (item.onClick) item.onClick(item)(evt);
            else if (onClickItem) onClickItem(item)(evt);
            else if (item.route) _navigate(item.route, item.target);
            else console.warn('Item clicked without click handler.', {item});
        }
    }

    function _navigate(route: string, target?: '_blank') {
        if (route.startsWith('http')) window.open(route, target);
        else navigate(route);
    }

    return (
        <DvrdHeader onClickItem={_onClickItem} backgroundColor={backgroundColor} color={color} className={className}
                    itemClassName={itemClassName} leftItems={leftItems} rightItems={rightItems}/>
    );
}